import { useState, useEffect } from 'react'
import { get } from 'aws-amplify/api'
import { getCachedAuthSession } from 'services/authSessionCache'

import { AwairRuntimeHistory } from 'types/AwairRuntimeHistory'

const DAY_IN_MILLIS = 24 * 60 * 60 * 1000

const useServerlessAwairRth = (
  deviceId: string,
  selectedDate: string,
  timeZone: string,
  refreshTimestamp: number,
  awairDeviceId: number | null
) => {
  const [awairRthData, setAwairRthData] = useState<AwairRuntimeHistory | null>(null)
  const [isAwairRthDataLoaded, setIsAwairRthDataLoaded] = useState(false)
  const [serverErrorOccurred, setServerErrorOccurred] = useState(false)
  const startTime = new Date(selectedDate)
  const endTime = new Date(startTime.getTime() + DAY_IN_MILLIS)
  const startDate = startTime.toISOString().slice(0, 10)
  const endDate = endTime.toISOString().slice(0, 10)

  useEffect(() => {
    if (!awairDeviceId) return

    (async () => {
      setIsAwairRthDataLoaded(false)
      const session = await getCachedAuthSession()

      try {
        const res = await get({
          apiName: 'dwaApi',
          path: `/awair-rth/${deviceId}?startDate=${startDate}&endDate=${endDate}&timezone=${timeZone}&awairDevice=${awairDeviceId}`,
          options: {
            headers: { 'Authorization': session?.tokens?.idToken?.toString() || '' }
          }
        }).response

        const rth = await res.body.json()

        setAwairRthData(rth as unknown as AwairRuntimeHistory)
      } catch {
        setAwairRthData(null)
        setServerErrorOccurred(true)
      } finally {
        setIsAwairRthDataLoaded(true)
      }
    })()
  }, [deviceId, startDate, endDate, timeZone, refreshTimestamp, awairDeviceId])

  return {
    awairEvents: awairRthData?.series ?? null,
    displayIndoorUnit: awairRthData?.displayIndoorUnit,
    areAwairEventsLoaded: isAwairRthDataLoaded,
    serverErrorOccurred
  }
}

export default useServerlessAwairRth
